import { useState, useEffect } from 'react';

const MIN_CHARS = 3;
const DEBOUNCE_MS = 300;

/**
 * Returns a debounced search value — empty string if input is below MIN_CHARS.
 * Does NOT fetch anything; caller owns the data layer.
 */
export function useDebouncedSearch(input: string): string {
  const [debounced, setDebounced] = useState('');

  useEffect(() => {
    if (input.length < MIN_CHARS) {
      setDebounced('');
      return;
    }

    const timer = setTimeout(() => setDebounced(input), DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [input]);

  return debounced;
}
